import gql from 'graphql-tag';

import dokkioUserFragment from '../fragments/dokkioUserFragment';

export const mutationUpdateDokkioUserPassword = gql`
  mutation updateDokkioUserPassword (
    $oldPassword: String
    $newPassword: String!
  ) {
    updateDokkioUserPassword (
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      ...dokkioUserFragment
    }
  }
  ${dokkioUserFragment}
`;
export default mutationUpdateDokkioUserPassword;
